import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

type DayjsInput = string | number | Date | null | undefined;

export const formatDate = (
  date: DayjsInput,
  format = 'DD.MM.YYYY',
  returnText = ''
): string => {
  const parsedDate = dayjs(date);
  const isValidDate = parsedDate.isValid();

  const resultDate = isValidDate ? parsedDate.format(format) : 'Invalid date';
  const isInvalidDate = resultDate === 'Invalid date';

  if (returnText) {
    return !isInvalidDate ? resultDate : returnText;
  }

  return !isInvalidDate ? resultDate : '';
};
